import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {objectContentElementInitialState, updateState,} from "../../../../common/utils/helpers";

const initialState = {
  souscription: objectContentElementInitialState,
};

const getDetailsSouscription = (state) => {
  return updateState("souscription", state, {
    ...objectContentElementInitialState,
    isLoading: true,
  });
};

const getDetailsSouscriptionSuccess = (state, payload) => {
  return updateState("souscription", state, {
    content: payload,
    isLoading: false,
    isSuccessed: true,
  });
};

const getDetailsSouscriptionFail = (state, payload) => {
  return updateState("souscription", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

/*************************************************************************** */
const detailsSouscriptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionsTypes.GET_DETAILS_SOUSCRIPTIONS:
      return getDetailsSouscription(state, action);
    case ActionsTypes.GET_DETAILS_SOUSCRIPTIONS_SUCCESS:
      return getDetailsSouscriptionSuccess(state, action.payload);
    case ActionsTypes.GET_DETAILS_SOUSCRIPTIONS_FAIL:
      return getDetailsSouscriptionFail(state, action.payload);
    default:
      return state;
  }
};

export default detailsSouscriptionsReducer;
